import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { NoteService } from '../../services/note.service';
import { NavigationHelper } from '../../helpers/navigation';
import { PottyNotesGestureController } from '../../utils/gesture.controller';
import { Router } from '@angular/router';
import { NavigationButtonsComponent } from '../../shared/navigation-buttons/navigation-buttons.component';

@Component({
    selector: 'pain-meter-container',
    templateUrl: 'pain-meter.html',
    styleUrls: ['pain-meter.scss'],
    standalone: false
})
export class PainMeterContainer implements OnInit {
	public static readonly ComponentIdentifier: number = 2;
	public activeStep = 3;
	public nextButtonText: string;
	public isStartOfFlow: boolean;
	public basePathToEmoji = 'assets/images/pain-meter/';
	public currentEmojiFileName = 'loudly-crying-face.svg';

	private initialTouchX: number | null = null;
	private initialTouchY: number | null = null;
	private touchStartTime: number | null = null;
	private hasScrolledEmojiOptions: boolean = false;

	@ViewChild('rangeComponent', { read: ElementRef }) rangeComponent: ElementRef;
	@ViewChild('navigationButtons', { read: ElementRef }) navigationButtons: ElementRef;
	@ViewChild(NavigationButtonsComponent) navigationButtonsComponent: NavigationButtonsComponent;

	constructor(private noteService: NoteService,
		private navigationHelper: NavigationHelper,
		private router: Router) {
	}

	ngOnInit(): void {
		this.isStartOfFlow = this.navigationHelper.isStartOfNoteFlow();
		this.nextButtonText = this.navigationHelper.isEndOfNoteFlow() ? 'Submit Note' : 'skip';
	}

	public setCurrentEmoji(fileName: string) {
		this.currentEmojiFileName = fileName;
		this.nextButtonText = 'next';
	}

	public savePainMeterMetadata(event: Event) {
		// If we haven't scrolled the emoji options, the assumption is that the user doesn't want to do a pain emoji.
		// Handles the case of the load in and instant swipe-skip.  
		const wasSkipped = this.navigationHelper.skipButtonPressed(event) || !this.hasScrolledEmojiOptions;
		this.noteService.setPainMeterEmojiPath(this.basePathToEmoji + this.currentEmojiFileName, wasSkipped);
	}

	// Gesture control 
	@HostListener('touchstart', ['$event'])
	public onTouchStart(event: TouchEvent): void {
		if (this.ignoreArea(event)) return;

		event.stopPropagation();
		this.initialTouchX = event.touches[0].clientX;
		this.initialTouchY = event.touches[0].clientY;
		this.touchStartTime = Date.now();
	}

	@HostListener('touchmove', ['$event'])
	public onTouchMove(event: TouchEvent): void {
		if (this.ignoreArea(event)) return;

		event.stopPropagation();

		if (this.initialTouchX === null || this.touchStartTime === null || this.initialTouchY == null) return;

		const currentTouchX = event.touches[0].clientX;
		const currentTouchY = event.touches[0].clientY;
		const deltaX = currentTouchX - this.initialTouchX;
		const deltaY = currentTouchY - this.initialTouchY;
		const timeDiff = Date.now() - this.touchStartTime

		// This represents moving backward in the add notes flow.
		if (PottyNotesGestureController.MovedRightEnough(timeDiff, deltaX, deltaY)) {
			this.savePainMeterMetadata(event);
			this.router.navigate([`${this.navigationHelper.getPreviousComponentUrl()}`]);
		}
		// Otherwise, forward.
		else if (PottyNotesGestureController.MovedLeftEnough(timeDiff, deltaX, deltaY)) {
			this.savePainMeterMetadata(event);
			this.router.navigate([`${this.navigationHelper.getNextComponentUrl()}`]);
		}
	}

	@HostListener('touchend', ['$event'])
	public onTouchEnd(event: TouchEvent): void {
		event.stopPropagation();
	}

	private ignoreArea(event: TouchEvent): boolean {
		const ticksElement = this.rangeComponent.nativeElement.querySelector('.ticks');
		const buttonElementsParentDiv = this.navigationButtons.nativeElement.querySelector('.buttons');
		if (!ticksElement) return false;	
	  
		const ticksRect = ticksElement.getBoundingClientRect();
		const buttonsRect = buttonElementsParentDiv.getBoundingClientRect();
	
		const touch = event.touches[0];
	  
		if ((touch.clientX >= ticksRect.left && touch.clientX <= ticksRect.right && touch.clientY >= ticksRect.top && touch.clientY <= ticksRect.bottom)
		   || (touch.clientX >= buttonsRect.left && touch.clientX <= buttonsRect.right && touch.clientY >= buttonsRect.top && touch.clientY <= buttonsRect.bottom)) 
		{
			this.hasScrolledEmojiOptions = true;
			return true;
		}

		  return false;
	}	
}
